var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@web/utility';
import { UserRoles } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var getBadgeColor = function (role) {
    switch (role) {
        case UserRoles.ADMIN:
            return 'bg-red-100 text-red-800';
        case UserRoles.USER:
            return 'bg-green-100 text-green-800';
        case UserRoles.MANAGER:
            return 'bg-blue-100 text-blue-800';
        default:
            return '';
    }
};
var RoleBadge = function (_a) {
    var role = _a.role;
    var t = useTranslation().t;
    var getBadgeText = function (role) {
        switch (role) {
            case UserRoles.ADMIN:
                return t('userRoles.admin');
            case UserRoles.USER:
                return t('userRoles.user');
            case UserRoles.MANAGER:
                return t('userRoles.manager');
            default:
                return '';
        }
    };
    return (_jsx("div", __assign({ className: classNames('h-6 py-1 px-3 text-xs font-medium inline-flex items-center justify-center rounded', getBadgeColor(role)) }, { children: _jsx("span", __assign({ className: classNames('overflow-hidden', getBadgeColor(role)) }, { children: getBadgeText(role) })) })));
};
export default RoleBadge;
